<template>
  <div class="ask-dialog-mask"
       v-if="isShowDialog">
    <div class="ask-dialog">
      <div class="ask-dialog-title">{{textList[type][0]}}</div>
      <div class="ask-dialog-text">
        <div class="ask-dialog-text-top">{{textList[type][1]}}</div>
        <div>{{textList[type][2]}}</div>
      </div>
      <div class="dialog-btn-line">
        <van-button class="dialog-btn"
                    @click="cancelClick">{{textList[type][3]}}</van-button>
        <van-button class="dialog-btn right-btn"
                    @click="confirmClick">{{textList[type][4]}}</van-button>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "slides",
  props: ["type"],
  data() {
    return {
      isShowDialog: false,
      textList: [[], [
        "确定要放弃付款吗？", "你放弃支付将失去一次为孩子", "提升的机会", "暂时放弃", "继续支付"
      ], [
        "待支付？", "你有一笔订单待支付", "赶紧去支付吧", "再看看", "去支付"
      ]]
    }
  },
  methods: {
    show() {
      this.isShowDialog = true
    },
    hide() {
      this.isShowDialog = false
    },
    confirmClick() {
      this.$emit("confirm")
    },
    cancelClick() {
      this.$emit("cancel")
    }
  }
}
</script>
<style lang="scss" scoped>
.ask-dialog-mask {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.6);
  z-index: 150;
  .ask-dialog {
    display: flex;
    flex-direction: column;
    align-items: center;
    border-radius: 15px;
    box-sizing: border-box;
    padding: 24px 0 30px;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    width: 310px;
    background: white;
    .ask-dialog-title {
      font-size: 16px;
      font-weight: 500;
      color: rgba(45, 46, 63, 1);
    }
    .ask-dialog-text {
      margin: 15px 0 39px;
      display: flex;
      flex-direction: column;
      align-items: center;
      font-size: 15px;
      font-family: PingFangSC-Regular;
      font-weight: 400;
      color: rgba(45, 46, 63, 1);
      .ask-dialog-text-top {
        margin-bottom: 9px;
      }
    }
    .dialog-btn-line {
      display: flex;
      justify-content: space-between;
      box-sizing: border-box;
      padding: 0 20px;
      width: 100%;
      .dialog-btn {
        border-radius: 26px;
        width: 130px;
        height: 52px;
        background: rgba(224, 224, 224, 1);
        font-size: 13px;
        font-weight: 400;
        text-align: center;
        color: rgba(89, 92, 109, 1);
      }
      .right-btn {
        background: #fe693f;
        color: white;
      }
    }
  }
}
</style>